<!-- <div class="grid grid-gap-5 g-toast">
    <div class="pad-10">
        <div class="zoho-icon" [style.background-position]="notificationIcon[data?.type]"></div>
    </div>
    <div class="grid grid-gap-5">
        <div class="f-w-500 head-c pad-t-10 font-14" *ngIf="!!data?.title">{{data?.title}}</div>
        <div class="pad-b-10 sub-c font-12">{{data?.message}}</div>
    </div>
    <div class="grid t-action-btn-con " style="height: 100%;">
        <button mat-button color="primary" (click)="snackBarRef.dismiss();"
            style="border-bottom: 1px solid whitesmoke;border-radius: 0;"
            class="toast-btn width-100 height-100 border-0">Okay</button>
        <button mat-button (click)="snackBarRef.dismiss()" style="border-radius: 0;" class="sub-c toast-btn">Close
            ({{countDown}}{{countDown>1?'\'s':'s'}})</button>
    </div>
</div> -->

<div class="grid grid-gap-5 common-toast warn {{data.type}} ">
  <button class="icon-btn-basic"  color="success">
    <mat-icon>{{data.icon}}</mat-icon>
  </button>
  <div class="grid grid-gap-5">
    <div class="f-w-500" *ngIf="!!data?.title">{{data?.title}}</div>
    <div class="{{!!data?.title?'font-14':''}}">{{data?.message}}</div>
  </div>
  <button class="icon-btn-basic warn"  (click)="snackBarRef.dismiss();emitHandle();">
    <mat-icon>close</mat-icon>
  </button>
</div>